<template>
    <div class="error-page">
        <div class="countdown-bg"></div>
        <div class="error-screen">
            <h1>404</h1>
            <h5>We're sorry but it looks<br />like that page doesn't exist anymore.</h5>
            <Button type="primary" @click="$router.push({ name: 'Home' })">Go back to Dashboard</Button>
        </div>
    </div>
</template>
<script>
import Button from '@/components/partials/Button';
export default {
    components: { Button }
};
</script>

<style lang="scss" scoped>
#app {
    .countdown-bg {
        background-image: url('../assets/img/consulting.svg');
    }
}
</style>
